module.exports = __webpack_public_path__ + "static/laseroterapia-image-4-2e983794e2e9c3233127d7b148f65f6b.png";